<app-sinclair-prosser *ngIf="isSinclair"></app-sinclair-prosser>